// UUIDv7 (RFC 9562): time-ordered, made on the device without coordination.
import { toHex } from "./bytes.ts";

export function uuidv7(now = Date.now()): string {
  const b = crypto.getRandomValues(new Uint8Array(16));
  let t = now;
  for (let i = 5; i >= 0; i--) { b[i] = t % 256; t = Math.floor(t / 256); }
  b[6] = (b[6]! & 0x0f) | 0x70;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const h = toHex(b);
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** Short random id for records created server-side (rooms, adults, staff). */
export function shortId(prefix: string, bytes = 10): string {
  const b = crypto.getRandomValues(new Uint8Array(bytes));
  const alphabet = "0123456789abcdefghjkmnpqrstvwxyz"; // Crockford base32, lower case
  let out = "";
  for (const x of b) out += alphabet[x & 31];
  return `${prefix}_${out}`;
}
